import { normalizeText } from "../utils/identity-utils";
import {
  SPECIALITY_EVIDENCE_KEY,
  getSpecialityEvidenceDocuments,
} from "../utils/document-policy";

export const DOCUMENT_REQUIREMENTS = {
  identityCopy: "Copia de Cédula",
  representativeIdentityCopy: "Copia de Cédula de Representante Legal",
  generalMedicalDegree: "Copia Título Médico General",
  specialtyDegreeMsp: "Copia Título de Especialidad (Emitido por el MISPAS)",
  exequaturCopy: "Copia de Exequátur",
  commercialRegistry: "Copia Registro Mercantil",
  rncCertification: "Certificación de RNC",
};

export const DOCUMENT_REQUIREMENT_MATRIX = {
  FISICA: {
    medical: [
      "identityCopy",
      "generalMedicalDegree",
      "specialtyDegreeMsp",
      "exequaturCopy",
    ],
    user: ["identityCopy"],
  },
  MORAL: {
    medical: [
      "representativeIdentityCopy",
      "generalMedicalDegree",
      "specialtyDegreeMsp",
      "exequaturCopy",
      "commercialRegistry",
      "rncCertification",
    ],
    user: ["representativeIdentityCopy", "commercialRegistry", "rncCertification"],
  },
};

export const getRequiredDocumentRequirements = (form) => {
  const personType = normalizeText(form.personType).toUpperCase();
  const group = DOCUMENT_REQUIREMENT_MATRIX[personType];
  if (!group || (form.isMedical !== true && form.isMedical !== false)) {
    return [];
  }

  const keys = form.isMedical ? group.medical : group.user;
  return keys.map((key) => ({
    key,
    label: DOCUMENT_REQUIREMENTS[key] || key,
  }));
};

export const getRequiredSupportingDocumentRequirements = (form) =>
  getRequiredDocumentRequirements(form).filter(
    ({ key }) => key !== SPECIALITY_EVIDENCE_KEY,
  );

export const areDocumentRequirementsCompleted = (form, documents = []) =>
  getRequiredSupportingDocumentRequirements(form).every((item) =>
    documents.some(
      (document) =>
        document.requirementKey === item.key && !document.specialityId,
    ),
  );

export const getRequiredDocumentsCount = (form) =>
  getRequiredDocumentRequirements(form).length;

export const getRequiredSupportingDocumentsCount = (form) =>
  getRequiredSupportingDocumentRequirements(form).length;

export const getRequiredDocumentsCountMessage = (requiredCount) =>
  `Debe adjuntar ${requiredCount} ${requiredCount === 1 ? "archivo" : "archivos"
  } en Soportes y Documentos, uno por cada requisito seleccionado. Las evidencias adicionales se agregan en el apartado de especialidad.`;

export const buildDocumentRequirementsPayload = (form, documents = []) =>
  getRequiredDocumentRequirements(form).map((item) => ({
    ...item,
    checked:
      item.key === SPECIALITY_EVIDENCE_KEY
        ? getSpecialityEvidenceDocuments(documents).length > 0
        : documents.some(
            (document) =>
              document.requirementKey === item.key && !document.specialityId,
          ),
  }));
